import React, { lazy, PropsWithChildren, Suspense } from "react";
import { Route } from "react-router-dom";

import OldTheme from "../theme/OldTheme";
import Can from "../components/can";
import { Route as RouteModel } from "./RouteModel";
import Loader from "../components/Loader";
import { Content } from "@volt_developers/react-ui-components";
const Page403 = lazy(() => import("../pages/Page403"));

const Wrapper = ({
  newTheme,
  withoutContent = false,
  children,
}: PropsWithChildren<{ newTheme: boolean; withoutContent: boolean }>) =>
  newTheme ? (
    <React.Fragment>{children}</React.Fragment>
  ) : (
    <>
      {withoutContent ? (
        <OldTheme>{children}</OldTheme>
      ) : (
        <Content>
          <OldTheme>{children}</OldTheme>
        </Content>
      )}
    </>
  );

export const buildChildRoutes = (
  routes: RouteModel[],
  withoutContent: boolean = false
) => {
  return flattenRoutes(routes)
    .filter(({ path }) => path)
    .map(
      ({
        path,
        can = null,
        newTheme = false,
        hasNestedSwitch = false,
        component: Component,
      }) => (
        <Route
          key={path}
          path={path}
          exact={!hasNestedSwitch}
          render={(props: any) => (
            <Wrapper newTheme={newTheme} withoutContent={withoutContent}>
              {can ? (
                <Suspense fallback={<Loader />}>
                  <Can do={can.do} on={can.on}>
                    {Component && <Component {...props} />}
                  </Can>
                  <Can not do={can.do} on={can.on}>
                    <Page403 />
                  </Can>
                </Suspense>
              ) : (
                <Suspense fallback={<Loader />}>
                  {Component && <Component {...props} />}
                </Suspense>
              )}
            </Wrapper>
          )}
        />
      )
    );
};

const flattenRoutes = (routes: RouteModel[]) => {
  const flattened: RouteModel[] = [];

  routes.forEach((route) => {
    if (route.children && route.children.length > 0) {
      flattened.push(...flattenRoutes(route.children));
    }
    flattened.push(route);
  });

  return flattened;
};
